import styled from "styled-components"
import media from '~/utils/media';

export const Container = styled.div`
  width: 100%;
  height: 80%;
  position: relative;

  > div.input-wrap {
    display: flex;
    align-items: center;
    padding: 4%;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    input {
      margin-left: 4%;
      font-size: 12px;

      ${media.mobileLarge`
        font-size: 10px;
      `}
      
      ${media.mobileMid`
        font-size: 10px;
      `}
      
      ${media.mobileSmall`
        font-size: 10px;
      `}
      
      border: 0;
      outline: none;
      width:100%;
      -webkit-appearance: button;
      & :focus {
        border-color: black;
      }
    }
  }

  .listItem {
    cursor: pointer;
    padding: 20px 0 20px;
    border-bottom: 1px solid #F5F5F5;
    font-size: 14px;
    &:hover{
    text-decoration: underline;
    }
  }
`

export const MessageWrapper = styled.div`
  margin: 70px auto;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: #656565;
  font-size: 14px;

  ${media.mobileLarge`
    font-size: 12px;
  `}

  ${media.mobileMid`
    font-size: 12px;
  `}

  ${media.mobileSmall`
    font-size: 12px;
  `}

`
